import React, { Component } from "react";
import PropTypes from "prop-types";
import YesNoModal from "../../../../../shared/components/modals/YesNoModal";

class ClearAllStatsModal extends Component {
  render() {
    const { isOpen, onAbort, onConfirm } = this.props;
    return (
      <YesNoModal
        onConfirm={onConfirm}
        onAbort={onAbort}
        isOpen={isOpen}
        reversedOrder={true}
        reversedHighlight={true}
      >
        <p>Are you sure you want to clear all stats?</p>
      </YesNoModal>
    );
  }
}

ClearAllStatsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onAbort: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  children: PropTypes.object,
};

export default ClearAllStatsModal;
